var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAR0lEQVR42mMYBTQCjMHnGvCLETZAAVkDiA0SAzIdiHeG1VQdmAYkzQKk+kYAmU1yOJDjf0w/Y4YJYYDpZ0SYkOl/hNgwTLUAmgwYc+QsUqkAAAAASUVORK5CYII=";
  export default img;